import { Injectable } from '@angular/core';

import { LogService, ApiService, AppContext } from './';

@Injectable()
export class FavoriteService {

  apiService: any = null;

  constructor(private logger: LogService, private api: ApiService, public app: AppContext) {
    this.apiService = api;
  }

  showSignInError() {
    // this.app.showMessage('Sign in Required', 'You must sign in to use this feature');
    this.app.showRegister();
  }

  favorite(type: string, id: number): Promise<any> {
    if (!this.app.isLoggedIn) {
      this.showSignInError();
      return;
    } else if (type === 'port') {
      return this.api.generateApiClient().then(client => this.callFavoritePort(client, id));
    } else if (type === 'vessel') {
      return this.api.generateApiClient().then(client => this.callFavoriteVessel(client, id));
    } else if (type === 'carrier') {
      return this.api.generateApiClient().then(client => this.callFavoriteCarrier(client, id));
    } else {
      return;
    }
  }

  unfavorite(type: string, id: number) {
    if (!this.app.isLoggedIn) {
      this.showSignInError();
      return;
    } else if (type === 'port') {
      return this.api.generateApiClient().then(client => this.callUnFavoritePort(client, id));
    } else if (type === 'vessel') {
      return this.api.generateApiClient().then(client => this.callUnFavoriteVessel(client, id));
    } else if (type === 'carrier') {
      return this.api.generateApiClient().then(client => this.callUnFavoriteCarrier(client, id));
    } else {
      return;
    }
  }

  unfavoriteRoute(originId: number, destinationId: number): Promise<any> {
    return this.api.generateApiClient().then(client => this.callUnFavoriteRoute(client, originId, destinationId));
  }

  callUnFavoriteRoute(apigClient: any, originId: number, destinationId: number): Promise<any> {
    this.logger.log('favorite.service', 'callUnFavoriteRoute', `${originId} + ${destinationId}`);
    var cognitoIdentityId = this.apiService.getCognitoId();
    return new Promise((resolve, reject) => {
      let params = {
        originId: originId,
        destinationId: destinationId
      };
      let body = {
        cognitoId: cognitoIdentityId,
        originId: originId,
        destinationId: destinationId
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };

      try {
        apigClient.v2RoutesFavoriteDelete(params, body, additionalParams)
          .then((result) => {
            this.logger.log('favorite.service', 'callUnFavoritePort result', result);
            resolve(result);
          }).catch((err) => {
            this.api.handleError(err);
            reject(err);
          });
      } catch (ex) {
        reject(ex);
      }
    });
  }

  callFavoritePort(apigClient: any, id: number): Promise<any> {
    this.logger.log('favorite.service', 'callFavoritePort', id);
    return new Promise((resolve, reject) => {
      let params = {
        portId: id
      };
      let body = {
        portId: id
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };

      try {
        apigClient.portsPortIdFavoritePost(params, body, additionalParams)
          .then((result) => {
            this.logger.log('favorite.service', 'callFavoritePort result', result);
            resolve(result);
          }).catch((err) => {
            this.api.handleError(err);
            reject(err);
          });
      } catch (ex) {
        reject(ex);
      }
    });
  }

  callUnFavoritePort(apigClient: any, id: number): Promise<any> {
    this.logger.log('favorite.service', 'callUnFavoritePort', id);
    return new Promise((resolve, reject) => {
      let params = {
        portId: id
      };
      let body = {
        portId: id
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };

      try {
        apigClient.portsPortIdFavoriteDelete(params, body, additionalParams)
          .then((result) => {
            this.logger.log('favorite.service', 'callUnFavoritePort result', result);
            resolve(result);
          }).catch((err) => {
            this.api.handleError(err);
            reject(err);
          });
      } catch (ex) {
        reject(ex);
      }
    });
  }

  callFavoriteVessel(apigClient: any, id: number): Promise<any> {
    this.logger.log('favorite.service', 'callFavoriteVessel', id);
    return new Promise((resolve, reject) => {
      let params = {
        vesselId: id
      };
      let body = {
        vesselId: id
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };

      try {
        apigClient.vesselsVesselIdFavoritePost(params, body, additionalParams)
          .then((result) => {
            this.logger.log('favorite.service', 'callFavoriteVessel result', result);
            resolve(result);
          }).catch((err) => {
            this.api.handleError(err);
            reject(err);
          });
      } catch (ex) {
        reject(ex);
      }
    });
  }

  callUnFavoriteVessel(apigClient: any, id: number): Promise<any> {
    this.logger.log('favorite.service', 'callUnFavoriteVessel', id);
    return new Promise((resolve, reject) => {
      let params = {
        vesselId: id
      };
      let body = {
        vesselId: id
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };

      try {
        apigClient.vesselsVesselIdFavoriteDelete(params, body, additionalParams)
          .then((result) => {
            this.logger.log('favorite.service', 'callUnFavoriteVessel result', result);
            resolve(result);
          }).catch((err) => {
            this.api.handleError(err);
            reject(err);
          });
      } catch (ex) {
        reject(ex);
      }
    });
  }

  callFavoriteCarrier(apigClient: any, id: number): Promise<any> {
    this.logger.log('favorite.service', 'callFavoriteCarrier', id);
    return new Promise((resolve, reject) => {
      let params = {
        carrierId: id
      };
      let body = {
        carrierId: id
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };

      try {
        apigClient.carriersCarrierIdFavoritePost(params, body, additionalParams)
          .then((result) => {
            this.logger.log('favorite.service', 'callFavoriteCarrier result', result);
            resolve(result);
          }).catch((err) => {
            this.api.handleError(err);
            reject(err);
          });
      } catch (ex) {
        reject(ex);
      }
    });
  }

  callUnFavoriteCarrier(apigClient: any, id: number): Promise<any> {
    this.logger.log('favorite.service', 'callUnFavoriteCarrier', id);
    return new Promise((resolve, reject) => {
      let params = {
        carrierId: id
      };
      let body = {
        carrierId: id
      };
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {}
      };

      try {
        apigClient.carriersCarrierIdFavoriteDelete(params, body, additionalParams)
          .then((result) => {
            this.logger.log('favorite.service', 'callUnFavoriteCarrier result', result);
            resolve(result);
          }).catch((err) => {
            this.api.handleError(err);
            reject(err);
          });
      } catch (ex) {
        reject(ex);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/favorite.service.ts